<template>
  <v-main class="pa-0" align-content="center">
    <div class="mx-10">ドラッグで並び替え、下の保存ボタンで保存してください</div>
    <div class="mx-10">非公開Lidについては並び替えできません</div>
    <draggable v-model="mylid" draggable=".item">
      <div v-for="item in mylid" :key="item.id" class="item">
        <v-card
          elevation="13"
          rounded
          height="50px"
          color="#cce8ff"
          class="mb-2 mx-5"
          ><v-card-text>{{ item.title }}</v-card-text></v-card
        >
      </div>
    </draggable>
    <v-btn
      tile
      width="200"
      elevation="0"
      color="#008CFF"
      class="white--text my-5 mx-10"
      @click="savelid()"
    >
      並び順を保存
    </v-btn>
  </v-main>
</template>
  <script>
import draggable from "vuedraggable";
import firebase from "firebase/app";
import "firebase/firestore";
export default {
  data() {
    return {
      db: firebase.firestore(),
      mylid: [],
      numlid: 0,
    };
  },
  created() {
    this.mylid = this.navlid;
    this.numlid = this.navlid.length;
  },
  components: {
    draggable: draggable,
  },
  computed: {
    lid() {
      return this.$store.state.lid;
    },
    navlid() {
      return this.$store.state.navlid;
    },
  },
  methods: {
    savelid() {
      const self = this;
      this.mylid.forEach(function (item, index) {
        self.db
          .collection("0")
          .doc(item.id)
          .update(
            {
              sort: String(self.numlid - index),
            },
            { merge: true }
          )
          .then(function (docRef) {
            self.$store.dispatch("getLid");
          })
          .catch(function (error) {
            console.error("Error Save Sort: ", error);
          });
      });
    },
  },
};
</script>
  